import { inject, Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { ContactType } from "@raptor-fe/core";
import { ServiceUtils } from '../service-utils/service-utils';
import { Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class ContactTypeApiService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    delete(tenantId: string, id: string): Observable<object> {
        return this.http.delete(this.serviceUtils.getBaseUrl('contacttype', tenantId) + `/${id}`);
    }

    getById(tenantId: string, id: string | null): Observable<ContactType | null> {
        if (!id || id === null) return of(<ContactType>{ id: null, tenantId: tenantId });

        return this.http.get<ContactType>(this.serviceUtils.getBaseUrl('contacttype', tenantId) + `/${id}`);
    }

    get(tenantId: string): Observable<ContactType[]> {
        return this.http.get<ContactType[]>(this.serviceUtils.getBaseUrl('contacttype', tenantId));
    }

    save(tenantId: string, contactType: ContactType): Observable<ContactType> {
        if (!contactType.id || contactType.id === null) return this.http.post<ContactType>(this.serviceUtils.getBaseUrl('contacttype', tenantId), contactType);
        else return this.http.put<ContactType>(this.serviceUtils.getBaseUrl('contacttype', tenantId), contactType);
    }

    sync(tenantId: string): Observable<object> {
        return this.http.post(this.serviceUtils.getBaseUrl('contacttype', tenantId) + '/sync', {});
    }
}